import axios from "axios";
import cache from "@/helpers/cache";

const groups = {

    key(params){
        return {type: 'groups', params};
    },

    async bulk(params = {}, force = false){
        let data = [];
        const key = groups.key(params);
        if( force || ! await cache.has( key ) ){
            data = (await axios.get('/api/group', {params})).data;
            await cache.remember(key, data);
        }else{
            data = await cache.get(key, data);
        }
        return data;
    },

    async get(id){
        let data = null;
        const key = groups.key({id});
        if( await cache.has( key ) ){
            data = (await axios.get(`/api/group/${id}`)).data;
            await cache.remember(key, data);
        }else{
            data = await cache.get(key, data);
        }
    },

    async create(tag){
        return (await axios.post(`/api/group/`, {tag})).data;
    },

    async update(id, tag){
        return (await axios.put(`/api/group/${id}`, {tag})).data;
    },

    async delete(id){
        return (await axios.delete(`/api/group/${id}`)).data;
    },


}

export default groups;
